import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useRequestVerificationMutation } from 'hooks/useRequestVerificationMutation';

interface EmailVerificationModalProps {
  open: boolean;
  onClose: () => void;
  userId: string;
  email: string;
  pendingEmail: string | null;
}

export const EmailVerificationModal = ({ open, onClose, userId, email, pendingEmail }: EmailVerificationModalProps) => {
  const { t } = useTranslation();
  const { mutate: requestVerification, isPending, isSuccess } = useRequestVerificationMutation();
  const hasRequestedVerification = useRef(false);

  useEffect(() => {
    if (open && pendingEmail === null && !hasRequestedVerification.current) {
      hasRequestedVerification.current = true;
      requestVerification(userId, {
        onError: () => {
          hasRequestedVerification.current = false;
        },
      });
    }
  }, [open, pendingEmail, userId, requestVerification]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('email_verification.modal_title')}</DialogTitle>
      <DialogContent>
        <Typography component="div" color="text.secondary">
          <Trans i18nKey="email_verification.banner_message" values={{ email: pendingEmail ?? email }} transSupportBasicHtmlNodes />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => requestVerification(userId)} disabled={isPending || isSuccess} variant="contained">
          {isSuccess ? t('email_verification.resend_success') : t('email_verification.resend_cta')}
        </Button>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
